<div class="clips-container d-flex flex-wrap" cdkDropListGroup>
	<div class="tags-col" [style.width.%]="mobileView ? 100 : 20">
		<mat-card class="mx-1 framed-content">
			<mat-card-header>
				<mat-card-title class="ms-3 me-2">
					<app-nav-map [load]="dataAdministrationType"></app-nav-map>

					<button
						class="filters-show-button"
						type="button"
						mat-raised-button
						color="primary"
						class="filters-show-button"
						aria-label="Toggle filters button"
						matTooltip="{{ (showFilters ? 'CLIPS.HIDE_FILTERS' : 'CLIPS.SHOW_FILTERS') | translate }}"
						matTooltipPosition="below"
						(click)="showFilters = !showFilters">
						@if (showFilters) {
						<mat-icon class="m-0">filter_alt_off</mat-icon>
						} @else {
						<mat-icon class="m-0">filter_alt</mat-icon>
						}
					</button>
				</mat-card-title>
			</mat-card-header>
			<app-tags [role]="'admin'" (actionRequested)="actionByTypeSplitter($event)"></app-tags>
		</mat-card>
	</div>

	<div
		class="clips-col"
		[style.width.%]="mobileView ? 100 : 80"
		infinite-scroll
		[infiniteScrollDistance]="scrollDistance"
		[infiniteScrollThrottle]="throttle"
		(wheel)="scrollPosition($event)"
		(scrolled)="onScrollDown($event)"
		[scrollWindow]="false"
		[alwaysCallback]="true">
		<span #inputFormAnchor></span>
		<mat-card class="pb-2 pt-1 framed-content">
			@switch (dataAdministrationType) { @case ('CLIPPING') {
			<app-clips-form [itemForEdit]="itemForEdit.clip" (actionRequested)="actionByTypeSplitter($event)"></app-clips-form>
			} @case ('SALES') {
			<app-sales-form [itemForEdit]="itemForEdit.sale" (actionRequested)="actionByTypeSplitter($event)"></app-sales-form>
			} @case ('BANKRUPTCIES') {
			<app-bankruptcies-form [itemForEdit]="itemForEdit.bankruptcy" (actionRequested)="actionByTypeSplitter($event)"></app-bankruptcies-form>
			} @case ('TRANSCRIPTIONS') {
			<app-shared-transcriptions-form [itemForEdit]="itemForEdit.transcription" [mode]="'admin'" (actionRequested)="actionByTypeSplitter($event)"></app-shared-transcriptions-form>
			} @case ('CONTRACT_ANNOUNCEMENTS') {
			<app-contract-notices-form
				[dataAdministrationType]="dataAdministrationType"
				[itemForEdit]="itemForEdit.contract_announcement"
				(actionRequested)="actionByTypeSplitter($event)"></app-contract-notices-form>
			} @case ('ANALYTICS') {
			} @default {
			<app-contract-notices-form
				[dataAdministrationType]="dataAdministrationType"
				[itemForEdit]="itemForEdit.contract_notice"
				(actionRequested)="actionByTypeSplitter($event)"></app-contract-notices-form>
			}}
		</mat-card>

		<div class="list-container">
			<span #listScrollAnchor></span>
			<mat-card class="framed-content">
				<div class="sticky-top">
					@switch (dataAdministrationType) { @case ('CLIPPING') { @if (showFilters) {
					<app-clips-filters
						[role]="'admin'"
						[clientsList]="clientsList"
						[resetFilters]="filtersStore"
						[apiLoading]="apiLoading"
						(actionRequested)="actionByTypeSplitter($event)"></app-clips-filters>
					}
					<app-clips-toolbar
						[selectedItems]="selectedItems"
						[totalItemsCount]="pagination.totalElements"
						[scrollToTop]="scrollToTop.active"
						[relatedClipsLoading]="relatedClipsLoading"
						(actionRequested)="actionByTypeSplitter($event)"></app-clips-toolbar>
					} @case ('SALES') { @if (showFilters) {
					<app-sales-filters
						[role]="'admin'"
						[dataAdministrationType]="dataAdministrationType"
						[apiLoading]="apiLoading"
						[resetFilters]="filtersStore"
						(actionRequested)="actionByTypeSplitter($event)"></app-sales-filters>
					}
					<app-sales-toolbar
						[selectedItems]="selectedItems"
						[totalItemsCount]="pagination.totalElements"
						[scrollToTop]="scrollToTop.active"
						(actionRequested)="actionByTypeSplitter($event)"></app-sales-toolbar>
					} @case ('BANKRUPTCIES') { @if (showFilters) {
					<app-bankruptcies-filters
						[role]="'admin'"
						[dataAdministrationType]="dataAdministrationType"
						[apiLoading]="apiLoading"
						[resetFilters]="filtersStore"
						(actionRequested)="actionByTypeSplitter($event)">
					</app-bankruptcies-filters>
					}
					<app-bankruptcies-toolbar
						[selectedItems]="selectedItems"
						[totalItemsCount]="pagination.totalElements"
						[scrollToTop]="scrollToTop.active"
						(actionRequested)="actionByTypeSplitter($event)"></app-bankruptcies-toolbar>
					} @case ('ANALYTICS') {
					} @case ('TRANSCRIPTIONS') { @if (showFilters) {
					<app-transcriptions-filters
						[role]="'admin'"
						[clientsList]="clientsList"
						[apiLoading]="apiLoading"
						[resetFilters]="filtersStore"
						(actionRequested)="actionByTypeSplitter($event)"></app-transcriptions-filters>
					}
					<app-transcriptions-toolbar
						[selectedItems]="selectedItems"
						[totalItemsCount]="pagination.totalElements"
						[scrollToTop]="scrollToTop.active"
						(actionRequested)="actionByTypeSplitter($event)"></app-transcriptions-toolbar>
					} @default { @if (showFilters) {
					<app-contract-notices-filters
						[role]="'admin'"
						[dataAdministrationType]="dataAdministrationType"
						[apiLoading]="apiLoading"
						[resetFilters]="filtersStore"
						[autotagUiEnabled]="autotagUiEnabled"
						(actionRequested)="actionByTypeSplitter($event)"></app-contract-notices-filters>
					}
					<app-contract-notices-toolbar
						[selectedItems]="selectedItems"
						[dataAdministrationType]="dataAdministrationType"
						[totalItemsCount]="pagination.totalElements"
						[scrollToTop]="scrollToTop.active"
						[autotagUiEnabled]="autotagUiEnabled"
						(actionRequested)="actionByTypeSplitter($event)"></app-contract-notices-toolbar>
					} }
				</div>

				<app-list-card-view
					[listItems]="itemsList"
					[itemsPerPage]="ITEMS_PER_PAGE"
					[preselectedItems]="preselectedItems"
					[appendModeActive]="appendModeActive"
					[highlightActive]="highlightItemId"
					[autotagUiEnabled]="autotagUiEnabled"
					(actionRequested)="actionByTypeSplitter($event)"></app-list-card-view>
			</mat-card>
		</div>
	</div>
</div>
